import React from 'react'
import './Cards.css'
import { ExternalLink } from 'react-external-link';

function CardItem(props) {
  return (
    <>
        <li className="cards__item">
            <ExternalLink href={props.path} className="cards__item__link">
                <div className="cards__item__pic--wrap">
                    <img src={props.src} alt="Portfolio Web" className="cards__item__img" />
                </div>
                <div className="cards__item__info">
                    <h5 className="cards__item__text">{props.text}</h5>
                </div>
            </ExternalLink>
        </li>
    </>
  )
}

export default CardItem